/* unplugin-vue-components disabled */import { render } from "./home.vue?vue&type=template&id=3c567cee&scoped=true"
import script from "./home.vue?vue&type=script&lang=js"
export * from "./home.vue?vue&type=script&lang=js"

import "./home.vue?vue&type=style&index=0&id=3c567cee&lang=less&scoped=true"

import exportComponent from "/opt/jenkins/workspace/zhishiOfficialweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c567cee"]])

export default __exports__